// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";.article-detail-content p span{font-family:\"微软雅黑\"!important}", ""]);
// Exports
module.exports = exports;
